import { graphql } from '../../../graphql/generated';

export const LOCALIZATIONS_CHOOSER_QUERY = graphql(`
  query LocalizationsChooser($id: ID!) {
    request(id: $id) {
      id
      orders {
        id
        orderLabels {
          id
          specimenId
          location
          localizationFieldValues {
            label
            unit
            value
            inputType
          }
        }
      }
    }
  }
`);
